import useCachedAdminConsoleData from "../../../../../hooks/redux/useCachedAdminConsoleData";
import AdminConsoleSectionList from "./sections/section/AdminConsoleSectionList";
import { isArrayNotEmpty } from "@duosoftbg/nacid-components";

const AdminConsoleConfig = () => {
  const { data } = useCachedAdminConsoleData();

  return <>{isArrayNotEmpty(data) && <AdminConsoleSectionList sections={data} />}</>;
};
export default AdminConsoleConfig;
